import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ModalAlerterCallback = (callback, swalConfig = null) => {
  const config = {
    title: 'ایا مطمئن هستید؟',
    showCancelButton: true,
    confirmButtonText: `بله`,
    cancelButtonText: 'خیر',
    confirmButtonColor: `#f299a2`,
    ...swalConfig,
  };

  MySwal.fire(config).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      return callback();
      // Swal.fire('Saved!', '', 'success')
    }
  });
};

export default ModalAlerterCallback;
